import { Injectable } from '@angular/core';
import { PersonManagerService } from './person-manager.service';

@Injectable({
  providedIn: 'root'
})
export class PersonPresenterService {

  LanguageHash = {
    ARA   : 'Arabic',
    ENG   : 'English',
    FRE   : 'French',
    GER   : 'German',
    GRE   : 'Greek (modern)',
    GUJ   : 'Gujarati',
    HIN   : 'Hindi',
    ITA   : 'Italian',
    KOR   : 'Korean',
    POL   : 'Polish',
    POR   : 'Portuguese',
    RUS   : 'Russian',
    SPA   : 'Spanish',
    TGL   : 'Tagalog',
    VIE   : 'Vietnamese',
    NA    : 'Other'
}

  constructor(
    private personManagerService: PersonManagerService
  ) { }

  fullName(id: number) {
    const person = this.personManagerService.get(id);
    let text = '';

    if (person.fullName.firstName) {
        text += person.fullName.firstName + ' ';
    }

    if (person.fullName.middleName) {
        text += person.fullName.middleName + ' ';
    }

    if (person.fullName.lastName) {
        text += person.fullName.lastName + ' ';
    }

    if (person.fullName.suffix) {
        text += person.fullName.suffix + ' ';
    }

    return text;
  }
  relationship(id: number) {
    const person = this.personManagerService.get(id);
    let relationship = person.relationship;

    if (relationship) {
        relationship = relationship.toLowerCase();
        return relationship.substr(0, 1).toUpperCase() + relationship.substr(1);
    }

    return null;
  }
  socialSecurityNumber(id: number) {
    const person = this.personManagerService.get(id);
    return person.ssn.ssnNumber;
  }
  dateOfBirth(id: number) {
    const person = this.personManagerService.get(id);
    return person.dateOfBirth;
  }
  gender(id: number) {
    const person = this.personManagerService.get(id);
    return person.gender === 'M' ? 'Male' :
                person.gender === 'F' ? 'Female' : null;
  }
  // residencySince(id: number) {
  //   const person = this.personManagerService.get(id);
  //   return person.residencySince;
  // }
  address(id: number, type?: 'billing' | 'mailing' | string) {
    const person = this.personManagerService.get(id);
    const address = this._address(person, type);
    let text = '';

    if (address) {

        if (address.addressLine1) {
            text += address.addressLine1 + '<br>';
        }

        if (address.addressLine2) {
            text += address.addressLine2 + '<br>';
        }

        if (address.city) {
            text += address.city + ', ';
        }

        if (address.state) {
            text += address.state + ' ';
        }

        if (address.zipcode) {
            text += address.zipcode;
        }

    }

    return text;

  }
  addressOnX(id: number, type?: 'billing' | 'mailing' | string) {

    const person = this.personManagerService.get(id);
    const address = this._address(person, type);
    let text = '';

    if (address) {

        if (address.address) {
            text += address.address + '<br>';
        }

        if (address.address2) {
            text += address.address2 + '<br>';
        }

        if (address.city) {
            text += address.city + ', ';
        }

        if (address.state) {
            text += address.state + ' ';
        }

        if (address.zipCode) {
            text += address.zipCode;
        }

    }

    return text;

  }
  phone(id: number, type) {
    const person = this.personManagerService.get(id);
    return this._phoneNumber(person, type);
  }
  pcpName(id: number) {
    const person = this.personManagerService.get(id);
    return person.pcp.name;
  }
  pcpNumber(id: number) {
    const person = this.personManagerService.get(id);
    return person.pcp.number;
  }
  pcpInd(id: number) {
    const person = this.personManagerService.get(id);
    return person.pcp.pcpInd ? 'Yes' : null;
  }
  language(id: number, type) {
    const person = this.personManagerService.get(id);
    const key = person[type];
    return this.LanguageHash[key];
  }
  ssn(id: number) {
    const person = this.personManagerService.get(id);
    return this._formatSSN(person.ssn.ssnNumber);
  }
  tobaccoInd(id: number) {
    const person = this.personManagerService.get(id);
    return person.tobaccoInd;
  }
  tobaccoLastUsed(id: number) {
    const person = this.personManagerService.get(id);
    return person.tobaccoLastUsed;
  }
  tobaccoDate(id: number) {
    const person = this.personManagerService.get(id);
    return person.tobaccoDate;
  }
  tobaccoUse(id: number) {
    let text = '';
    const over18 = this.personManagerService.isLegalSmokingAge(id);

    if (this.tobaccoInd(id) === true || this.tobaccoInd(id) === 'Y') {
        text += 'Yes<br>';
        text += this.tobaccoLastUsed(id);
    } else if (this.tobaccoInd(id) === false || this.tobaccoInd(id) === 'N') {
        if (over18) {
            text += 'No';
        }
    }

    return text;
  }
  tobaccoUseOnX(id: number) {
    let text = '';
    const over18 = this.personManagerService.isLegalSmokingAge(id);

    if (this.tobaccoInd(id) === true || this.tobaccoInd(id) === 'Y') {
        text += 'Yes';
    } else if (this.tobaccoInd(id) === false || this.tobaccoInd(id) === 'N') {
        if (over18) {
            text += 'No';
        }
    }

    return text;
  }
  materials(id: number, websiteURL) {
    const person = this.personManagerService.get(id);
    const contentArray = [];

    if (person.receiveVia.electronically) {
        contentArray.push('Electronically by logging into ' + websiteURL + '</a>');
    }

    if (person.receiveVia.mail) {
        contentArray.push('In the mail at the address noted above');
    }

    return contentArray.length > 0 ? contentArray.join('<br>') : null;
  }
  email(id: number) {
    const person = this.personManagerService.get(id);

    if (person.email) {
        return person.email;
    } else if ( (person as any).emailAddress) {
      return (person as any).emailAddress;
    } else if (person.email) {
        return person.email;
    }
  }
  marketing(id: number) {
    const person = this.personManagerService.get(id);
    const text = [];

    if (person.emailInd) {
        text.push(person.email);
    }

    if (person.cellNumberInd) {
        text.push(this._formatPhoneNumber(person.cellNumber));
    }

    return text.join('<br>');
  }
  specialAssistance(id: number) {
    const person = this.personManagerService.get(id);
    return person.specialAssistance ? 'Yes' : 'No';
  }
  _address(person, type?: 'billing' | 'mailing' | string) {

    if (type === 'billing') {
        if (person.sameMailingAddress) {
            return person.homeAddress;
        } else if (person.isMailingBilling) {
            return person.mailingAddress;
        } else {
            return person.billingAddress;
        }
    } else if (type === 'mailing') {
        if (person.sameMailingAddress) {
            return person.homeAddress;
        } else {
            return person.mailingAddress;
        }
    } else {
      if (person.sameAddressAsSubscriber || person.sameMailingAddress) {
        const subscriber = this.personManagerService.query(p => p.relationship === 'Subscriber')[0];
        return subscriber.homeAddress;
      } else {
        return person.homeAddress;
      }
    }
  }
  _phoneNumber(person, type) {
    if (person.phoneNumber) {
      return this._formatPhoneNumber(person.phoneNumber);
    } else {
      if (type === 'primary') {
          return this._formatPhoneNumber(person.primaryPhoneNumber);
      } else if (type === 'other') {
          return this._formatPhoneNumber(person.otherPhoneNumber);
      } else if (type === 'cell') {
          return this._formatPhoneNumber(person.cellNumber);
      }
    }
  }
  _formatPhoneNumber(digits) {
    if (digits) {
      digits = String(digits);
      digits = digits.replace(/[^0-9]/g, '');
      digits = digits.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
    return digits;
  }
  _formatSSN(digits) {
    if (digits) {
      digits = String(digits);
      digits = digits.replace(/[^0-9]/g, '');
      digits = digits.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
    }

    return digits;
  }

}
